import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-content-menu.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-content-menu.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AflaModuleStrategyService } from "../../services/afla-module-strategy/afla-module-strategy.service";
import { UserInformationService } from "../../services/user/user-information.service";
import { AppControllerService } from "../../../app-controller.service";
import { ViewApplicationService } from "../../../application/view-application/view-application.service";
import { filter, Subject, take, takeUntil } from "rxjs";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { WorkflowJobService } from "../../services/workflow-job/workflow-job.service";
import { RouterParamsService } from "../../services/route-params.service";
import { ViewApplicationStepManagementConstants } from "src/app/application/view-application/view-application-step-management/view-application-step-management.constants";
import { AlertType } from "../../models/alert";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { CancelApplicationConfirmationComponent } from "./cancel-application-confirmation/cancel-application-confirmation.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CurrentStepService } from "../../services/current-step/current-step.service";
let ViewApplicationContentMenuComponent = class ViewApplicationContentMenuComponent {
    router;
    moduleStrategyService;
    userInformationService;
    routerParamsService;
    route;
    modalService;
    appController;
    jobService;
    currentStepService;
    changeDetectorRef;
    viewApplicationService;
    appControllerService;
    pageHeading;
    menuItems;
    relativeLinks = true;
    selectedModule;
    TerminateApplicationText = "Withdraw Application";
    _destroy$ = new Subject();
    selectedModuleName = "";
    selectedOrganisationName = "";
    checkStateSubscription;
    isCurrentStepEnd = false;
    jobCurrentStepsSubscription;
    getCurrentStepsSubscription;
    getMoveToStepsSubscription;
    getAdHocMoveToWorkflowStepObservableSubscription;
    listenForRouteParamChangesSubscription;
    currentModule;
    currentJobId;
    nextSteps;
    dialogOptions = {
        size: "lg",
        centered: true,
        backdrop: "static",
    };
    constructor(router, moduleStrategyService, userInformationService, routerParamsService, route, modalService, appController, jobService, currentStepService, changeDetectorRef, viewApplicationService, appControllerService) {
        this.router = router;
        this.moduleStrategyService = moduleStrategyService;
        this.userInformationService = userInformationService;
        this.routerParamsService = routerParamsService;
        this.route = route;
        this.modalService = modalService;
        this.appController = appController;
        this.jobService = jobService;
        this.currentStepService = currentStepService;
        this.changeDetectorRef = changeDetectorRef;
        this.viewApplicationService = viewApplicationService;
        this.appControllerService = appControllerService;
        this.selectedModule = this.userInformationService.getModuleInformation(+this.appControllerService.selectedModuleID);
        this.selectedModuleName = this.selectedModule?.name;
        this.selectedOrganisationName = this.selectedModule?.organisation?.name;
        this.checkState();
    }
    ngOnInit() {
        this.viewApplicationService.$currentTitlesObservable.subscribe(t => {
            if (t)
                this.pageHeading = t.ViewApplicationTitle;
        });
        this.listenForRouteParamChanges();
        this.getCurrentStepDetails();
    }
    listenForRouteParamChanges() {
        const onlyValidParams = this.routerParamsService.params.pipe(filter(param => param.moduleid || param.organisationid));
        this.listenForRouteParamChangesSubscription = onlyValidParams.subscribe((params) => {
            if (params) {
                if (params.moduleid) {
                    this.currentJobId = params.jobID;
                    this.userInformationService.$systemModules.pipe(takeUntil(this._destroy$), take(1)).subscribe((modules) => {
                        if (modules !== undefined && modules !== null && modules.length > 0) {
                            this.currentModule = this.userInformationService.getModuleInformation(+params.moduleid);
                        }
                    });
                }
            }
        });
    }
    getCurrentStepDetails() {
        this.getCurrentStepsSubscription = this.currentStepService.getCurrentSteps(+this.currentJobId, this.currentModule.id).subscribe({
            next: (data) => {
                if (data.length > 0 && data[0].type == "End") {
                    this.isCurrentStepEnd = true;
                }
                else {
                    this.isCurrentStepEnd = false;
                }
                this.changeDetectorRef.detectChanges();
            },
            error: error => {
                this.appController.handleServerErrorMessage(ViewApplicationStepManagementConstants.COMPONENT_NAME, error, CRUDOperation.Get);
            }
        });
    }
    routeToMenuItem(menuItem) {
        if (this.relativeLinks) {
            this.router.navigate([menuItem.address], { relativeTo: this.route });
        }
        else {
            this.router.navigate([menuItem.address]);
        }
    }
    checkState() {
        if (this.menuItems && this.pageHeading) {
            return;
        }
        if (this.moduleStrategyService.dynamicTitle.ViewApplicationTitle && !this.pageHeading)
            this.pageHeading = this.moduleStrategyService.dynamicTitle.ViewApplicationTitle;
        this.checkStateSubscription = this.route.data
            .subscribe((data) => {
            this.menuItems = data.menuItems;
        });
    }
    terminateApplication($event) {
        const dialogRef = this.modalService.open(CancelApplicationConfirmationComponent, this.dialogOptions);
        dialogRef.componentInstance.title = "Withdraw Application";
        dialogRef.componentInstance.description = "Are you sure you want to withdraw the current application?";
        dialogRef.result.then(rejection => {
            if (rejection) {
                this.getMoveToStepsSubscription = this.currentStepService.getMoveToSteps(this.currentModule.id.toString(), this.currentJobId.toString()).subscribe({
                    next: (response) => {
                        this.nextSteps = response.sort((a, b) => (a.name > b.name) ? 1 : -1);
                        let endStep = this.nextSteps.filter(s => s.name == "End")[0];
                        const params = {
                            nextStepId: endStep.id.toString(),
                            jobId: this.currentJobId,
                            reason: "Manual Termination of Job"
                        };
                        this.getAdHocMoveToWorkflowStepObservableSubscription =
                            this.viewApplicationService.getAdHocMoveToWorkflowStepObservable(params)
                                .subscribe({
                                next: result => {
                                    this.viewApplicationService.getCurrentStepEvent.emit(result);
                                    this.appController.showMessage(ViewApplicationStepManagementConstants.SUCCESS_MESSAGE, AlertType.Success);
                                    this.getCurrentStepsSubscription = this.currentStepService.getCurrentSteps(+this.currentJobId, this.currentModule.id).subscribe({
                                        next: (data) => {
                                            this.viewApplicationService.updateTracker();
                                            if (data.length > 0 && data[0].type == "End") {
                                                this.isCurrentStepEnd = true;
                                            }
                                            else {
                                                this.isCurrentStepEnd = false;
                                            }
                                            this.changeDetectorRef.detectChanges();
                                        },
                                        error: error => {
                                            this.appController.handleServerErrorMessage(ViewApplicationStepManagementConstants.COMPONENT_NAME, error, CRUDOperation.Get);
                                        }
                                    });
                                }
                            });
                        this.changeDetectorRef.detectChanges();
                    },
                    error: error => {
                        this.appController.handleServerErrorMessage(ViewApplicationStepManagementConstants.COMPONENT_NAME, error, CRUDOperation.Get);
                    }
                });
            }
        });
    }
    static ctorParameters = () => [
        { type: Router },
        { type: AflaModuleStrategyService },
        { type: UserInformationService },
        { type: RouterParamsService },
        { type: ActivatedRoute },
        { type: NgbModal },
        { type: AppControllerService },
        { type: WorkflowJobService },
        { type: CurrentStepService },
        { type: ChangeDetectorRef },
        { type: ViewApplicationService },
        { type: AppControllerService }
    ];
    static propDecorators = {
        pageHeading: [{ type: Input }],
        menuItems: [{ type: Input }],
        relativeLinks: [{ type: Input }]
    };
};
ViewApplicationContentMenuComponent = __decorate([
    Component({
        selector: "app-view-application-content-menu",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ViewApplicationContentMenuComponent);
export { ViewApplicationContentMenuComponent };
